import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    agencies: []
};

export const agenciesSlice = createSlice({
    name: 'agenciesSlice',
    initialState,
    reducers: {

        getAllAgencies: (state, action) => {
            state.agencies = action.payload;
        }
    },
});

// Action creators are generated for each case reducer function
export const { getAllAgencies } = agenciesSlice.actions;

export default agenciesSlice.reducer;
